import React from 'react';
import { withSnackbar } from 'notistack';
import { withStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import Backdrop from '@material-ui/core/Backdrop';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Add from '@material-ui/icons/Add';
import PupilFab from './PupilFab';
import AddChildDialog from './AddChildDialog';
import store from '../../store/index';
import { appColours } from '../../helpers';

const colours = appColours();
const styles = () => ({
  fabButton: {
    color: '#fff',
    fontSize: 20,
    backgroundColor: '#f56a12',
    '&:hover': {
      backgroundColor: '#C24C03',
    },
  },
  fabBackdrop: {
    zIndex: 98,
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
  },
  fabPupilSelector: {
    zIndex: 99,
    position: 'fixed',
    right: 0,
    bottom: 0,
    padding: 16,
  },
  fabPupilSelectorItem: {
    position: 'relative',
  },
  fabPupilSelectorItemText: {
    padding: '4px 8px',
    marginTop: 4,
  },
  fabPupilSelectorItemTextNarrow: {
    padding: '4px 8px',
    marginTop: 12,
  },
  fabPupilSelectorItemTextFirstName: {
    fontSize: 16,
  },
  fabPupilSelectorItemTextLastName: {
    fontSize: 12,
  },
});

class PupilSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pupils: [],
      isDialogOpen: false,
    };

    this.onAddPupilClick = this.onAddPupilClick.bind(this);
    this.onClickAway = this.onClickAway.bind(this);
    this.onDialogClose = this.onDialogClose.bind(this);
  }

  componentDidMount() {
    this.storeSubscription = store.subscribe(() => {
      this.updatePupilsList();
    });

    this.updatePupilsList();
  }

  componentWillUnmount() {
    if (this.storeSubscription) {
      this.storeSubscription();
    }
  }

  updatePupilsList() {
    const storeState = store.getState();
    const { pupils } = storeState;

    this.setState({ pupils });
  }

  onAddPupilClick() {
    this.setState({
      isDialogOpen: true,
    });
  }

  onDialogClose() {
    this.setState({
      isDialogOpen: false,
    });
  }

  onClickAway() {
    if (
      this.props.onClickAway
      && !this.state.isDialogOpen
    ) {
      this.props.onClickAway();
    }
  }

  render() {
    const {
      pupils,
      isDialogOpen,
    } = this.state;
    const {
      classes,
      onPupilClick,
      onPupilAdded,
    } = this.props;

    return (
      <div className="pupil-selector">
        <Backdrop
          className={classes.fabBackdrop}
          open
        />
        <ClickAwayListener
          onClickAway={this.onClickAway}
        >
          <div className={classes.fabPupilSelector}>
            <Grid
              className={classes.fabPupilSelectorItem}
              justify="space-between"
              container
              spacing={4}
            >
              <Grid item>
                <Paper>
                  <div className={classes.fabPupilSelectorItemTextNarrow}>
                    Add pupil
                  </div>
                </Paper>
              </Grid>
              <Grid item>
                <Fab
                  className={classes.fabButton}
                  onClick={this.onAddPupilClick}
                >
                  <Add />
                </Fab>
              </Grid>
            </Grid>
            {pupils.map((pupil, index) => {
              const colourIndex = index % colours.length;
              return (
                <Grid
                  key={pupil.id}
                  className={classes.fabPupilSelectorItem}
                  justify="flex-end"
                  container
                  spacing={4}
                >
                  <Grid item>
                    <Paper onClick={onPupilClick.bind(this, pupil)}>
                      <div className={classes.fabPupilSelectorItemText}>
                        <div className={classes.fabPupilSelectorItemTextFirstName}>
                          {pupil.first_name}
                        </div>
                        <div className={classes.fabPupilSelectorItemTextLastName}>
                          {pupil.last_name}
                        </div>
                      </div>
                    </Paper>
                  </Grid>
                  <Grid item>
                    <PupilFab
                      onPupilClick={onPupilClick.bind(this, pupil)}
                      initial={pupil.first_name[0]}
                      backgroundColor={colours[colourIndex][0]}
                      backgroundColorHover={colours[colourIndex][1]}
                    />
                  </Grid>
                </Grid>
              );
            })}
          </div>
        </ClickAwayListener>
        <AddChildDialog
          isDialogOpen={isDialogOpen}
          onPupilAdded={onPupilAdded}
          onDialogClose={this.onDialogClose}
          useSuspense={false}
        />
      </div>
    );
  }
}

export default withStyles(styles)(withSnackbar(PupilSelector));
